import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { NEW } from '@lib/enums/common';
import { NavItemArgs } from './types';

export default function getAssetsNavItem(args: NavItemArgs) {
  const { id = '', pathname, t, urlParams, getUserAccessByComponent } = args;
  const isAssetsAvailable =
    getUserAccessByComponent(AccessComponentEnum.AssetsManagement) !==
    AccessLevelEnum.LimitedRead;
  const isAssetCategoriesAvailable =
    getUserAccessByComponent(AccessComponentEnum.AssetCategoriesManagement) !==
    AccessLevelEnum.LimitedRead;
  const isAssetCountersAvailable =
    getUserAccessByComponent(AccessComponentEnum.AssetsCounterReading) !==
    AccessLevelEnum.LimitedRead;
  const children: NavItem<unknown>[] = [];
  let to: string | undefined;
  if (isAssetsAvailable) {
    to = APP_URLS.dashboard.assets.index.getPathWithQuery();
    children.push({
      id: 'all-assets',
      title: t('all-assets'),
      to: APP_URLS.dashboard.assets.index.getPathWithQuery(),
      type: NavItemTypeEnum.PrimarySub,
      end: true,
      predictorFnActive: () => {
        return (
          APP_URLS.dashboard.assets.view.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.assets.edit.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.assets.add.isTheSameUrlAs(pathname) ||
          APP_URLS.dashboard.assets.nomenclature.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.assets.counter.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.assets.document.isTheSameUrlAs(pathname, {
            pathParts: { id, documentId: urlParams?.documentId || NEW },
          }) ||
          APP_URLS.dashboard.assets.interventions.isTheSameUrlAs(pathname, {
            pathParts: { id },
          })
        );
      },
    });
  }
  if (isAssetCountersAvailable) {
    if (!to) to = APP_URLS.dashboard.assets.counters.getPathWithQuery();
    children.push({
      id: 'counter-monitoring',
      title: t('counter-monitoring'),
      to: APP_URLS.dashboard.assets.counters.getPathWithQuery(),
      type: NavItemTypeEnum.PrimarySub,
      end: true,
    });
  }
  if (isAssetCategoriesAvailable) {
    if (!to) to = APP_URLS.dashboard.assets.categories.getPathWithQuery();
    children.push({
      id: 'asset-categories',
      title: t('categories'),
      to: APP_URLS.dashboard.assets.categories.getPathWithQuery(),
      type: NavItemTypeEnum.PrimarySub,
      end: true,
    });
  }
  if (to) {
    return {
      id: 'assets',
      title: t('assets'),
      leftIcon: Icons.inventory,
      to,
      type: NavItemTypeEnum.Primary,
      predictorFnVisible: () =>
        isAssetsAvailable ||
        isAssetCountersAvailable ||
        isAssetCategoriesAvailable,
      children,
    };
  }
  return undefined;
}
